import '@styles/webdesktop/stylesheets/typography.scss';
import '@styles/webdesktop/stylesheets/svgIcon.scss';
import React from 'react';
import { SvgIconType } from './SvgIconType';
import { Size } from '@front/sharedcomponents/Variables';
import AddIcon from '@styles/webdesktop/Icons/add.svg';
import VisibleDataIcon from '@styles/webdesktop/Icons/visibleData.svg';
import InvisibleDataIcon from '@styles/webdesktop/Icons/invisibleData.svg';
import CopyIcon from '@styles/webdesktop/Icons/copy.svg';
import OverlayIcon from '@styles/webdesktop/Icons/overlayButton.svg';
import IndicatorIcon from '@styles/webdesktop/Icons/indicatorButton.svg';
import ToolsIcon from '@styles/webdesktop/Icons/toolsButton.svg';
import OrderEntryIcon from '@styles/webdesktop/Icons/orderEntry.svg';
import MouseTradeIcon from '@styles/webdesktop/Icons/mouseTradeButton.svg';
import ObjectManagerIcon from '@styles/webdesktop/Icons/objectManagerButton.svg';
import CheckboxIcon from '@styles/webdesktop/Icons/checkbox.svg';
import ArrowDownIcon from '@styles/webdesktop/Icons/arrowDown.svg';
import ArrowUpIcon from '@styles/webdesktop/Icons/arrowUp.svg';
import ArrowRightIcon from '@styles/webdesktop/Icons/arrowRight.svg';
import EditIcon from '@styles/webdesktop/Icons/editIcon.svg';
import CloseIcon from '@styles/webdesktop/Icons/closeCrossBtn.svg';
import MenuErrorIcon from '@styles/webdesktop/Icons/menuError.svg';
import UpdateNotificationArrowIcon from '@styles/webdesktop/Icons/updateNotificationArrow.svg';
import SearchIcon from '@styles/webdesktop/Icons/search.svg';
import BetaIcon from '@styles/webdesktop/Icons/beta.svg';
import InstrumentLookupIcon from '@styles/webdesktop/Icons/instrumentLookup.svg';
import PositionSizingIcon from '@styles/webdesktop/Icons/positionSizing.svg';
import TrailingStopIcon from '@styles/webdesktop/Icons/trailingStop.svg';
const ICONS_MAP = {
    [SvgIconType.Add]: React.createElement(AddIcon, null),
    [SvgIconType.VisibleData]: React.createElement(VisibleDataIcon, null),
    [SvgIconType.InvisibleData]: React.createElement(InvisibleDataIcon, null),
    [SvgIconType.Copy]: React.createElement(CopyIcon, null),
    [SvgIconType.Overlay]: React.createElement(OverlayIcon, null),
    [SvgIconType.Indicator]: React.createElement(IndicatorIcon, null),
    [SvgIconType.Tools]: React.createElement(ToolsIcon, null),
    [SvgIconType.OrderEntry]: React.createElement(OrderEntryIcon, null),
    [SvgIconType.MouseTrade]: React.createElement(MouseTradeIcon, null),
    [SvgIconType.ObjectManager]: React.createElement(ObjectManagerIcon, null),
    [SvgIconType.Checkbox]: React.createElement(CheckboxIcon, null),
    [SvgIconType.ArrowDown]: React.createElement(ArrowDownIcon, null),
    [SvgIconType.ArrowUp]: React.createElement(ArrowUpIcon, null),
    [SvgIconType.ArrowRight]: React.createElement(ArrowRightIcon, null),
    [SvgIconType.Edit]: React.createElement(EditIcon, null),
    [SvgIconType.Close]: React.createElement(CloseIcon, null),
    [SvgIconType.MenuError]: React.createElement(MenuErrorIcon, null),
    [SvgIconType.UpdateNotificationArrow]: React.createElement(UpdateNotificationArrowIcon, null),
    [SvgIconType.Search]: React.createElement(SearchIcon, null),
    [SvgIconType.Beta]: React.createElement(BetaIcon, null),
    [SvgIconType.InstrumentLookup]: React.createElement(InstrumentLookupIcon, null),
    [SvgIconType.PositionSizing]: React.createElement(PositionSizingIcon, null),
    [SvgIconType.TrailingStop]: React.createElement(TrailingStopIcon, null)
};
export const SvgIcon = ({ icon, size = Size.Medium }) => {
    const iconElement = ICONS_MAP[icon];
    if (isNullOrUndefined(iconElement)) {
        return null;
    }
    const sizeClass = size === Size.None ? '' : size;
    const classNames = ['svg-icon', sizeClass];
    const className = classNames.filter(Boolean).join(' ');
    return React.createElement("span", { className: className }, iconElement);
};
